import { useIntl } from "react-intl";
import styles from "./Card.module.scss";

export type CardContent = {
  name: string;
  slug: string;
};

export type CardProps = CardContent & {
  urlPrefix: string;
};

export const Card = ({ name, slug, urlPrefix }: CardProps) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <a className={styles.title} href={`${urlPrefix}${slug}`}>
        <span>
          {intl.formatMessage(
            { id: "rentingVehicles" },
            { name: name, br: () => <br /> }
          )}
        </span>
      </a>
    </div>
  );
};
